import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css'; // Importa os estilos globais
import CookieBanner from './components/CookieBanner'; // Onde você salvou o banner
import image from './nitricOxide.jpg'
import FullScreenBackground from './components/background';
import PrivacyPolicy from './components/PrivacyPolice';

// URL para onde o usuário será redirecionado após aceitar os cookies
const REDIRECT_URL = 'https://www.digistore24.com/redir/538695/caminhoconsciente/'; // Substitua pela sua URL real

function App() {
 return (
    <Router>
      <Routes>
        {/* ROTA PRINCIPAL: A Landing Page com a imagem de fundo */}
        <Route 
          path="/" 
          element={
            <div className="app-container">
              <FullScreenBackground imageUrl={image} />
              {/* O Banner aparece aqui, na home */}
              <CookieBanner onAcceptRedirectUrl={REDIRECT_URL} />
            </div>
          } 
        />

        {/* ROTA DA POLÍTICA: Apenas o texto sério da política */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
};

export default App;